// removed by extract-text-webpack-plugin
module.exports = {"ShareholdersContainer":"ShareholdersContainer-3jdrxtz2vb3e7p2md2r316dnn1et9813p6jc36a76a35hzabh62mta897nemrzasvkyf6r795972ce92gef6u3xmnb3pwrg8jk5v6zf"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Shareholders/ShareholdersView.module.scss
// module id = 1718
// module chunks = 0